/**
 * @file ForbiddenPage.tsx
 * @description 403 — Доступ запрещён (phase08.5 shadcn; phase19.29 — тема
 * и логотип Commora через CommoraAuthShell).
 */

import { useLocation, useNavigate } from "react-router";

import { CommoraAuthShell } from "../components/brand/CommoraAuthShell";
import { EditorialCard } from "../components/ui/EditorialCard";
import { Button } from "../components/ui/button";

interface LocationState {
  reason?: string;
  redirectedFrom?: string;
}

export function ForbiddenPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = (location.state ?? null) as LocationState | null;

  return (
    <CommoraAuthShell tabTitle="Нет доступа">
      <EditorialCard floating className="w-full">
        <EditorialCard.Body>
          <div className="flex flex-col gap-4 items-center text-center">
            <h1 className="type-page-title text-on-surface">
              Нет доступа
            </h1>
            <p className="text-sm text-on-surface-variant">
              {state?.reason ??
                "У вашей роли нет прав на этот раздел. Обратитесь к администратору, если это ошибка."}
            </p>
            {state?.redirectedFrom ? (
              <p className="text-xs text-on-surface-muted font-mono">
                {state.redirectedFrom}
              </p>
            ) : null}
            <Button variant="outline" onClick={() => navigate(-1)}>Назад</Button>
          </div>
        </EditorialCard.Body>
      </EditorialCard>
    </CommoraAuthShell>
  );
}
